export const FORCED_DEFAULT_VALXML_VALUES = {
    'ValXML.BIISValuationData.General.ArealUnit': 'qm',
    'ValXML.BIISValuationData.ValuationResults.Currency': 'EUR',
} as const

export const ROOT_DATE_VALXML_PATH = 'ValXML.Date'

export type ForcedDefaultValXmlField = keyof typeof FORCED_DEFAULT_VALXML_VALUES

export const FORCED_DEFAULT_VALXML_FIELDS = Object.keys(FORCED_DEFAULT_VALXML_VALUES) as ForcedDefaultValXmlField[]

export const REQUIRED_IMPORT_DEFAULT_NOTE = 'Pflichtfeld fuer Backend-Import. Kein expliziter Wert im PDF gefunden; Defaultwert gesetzt.'

export const MANUAL_ENTRY_CONFIDENCE = -0.01
export const MISSING_SOURCE_CONFIDENCE_CAP = 0.3

export { MAX_PLAYGROUND_FILE_SIZE_BYTES as MAX_VALXML_PDF_FILE_SIZE_BYTES } from 'ComponentLibrary/src/playground/shared/upload/file-size'
